export class ResourceExpiredError extends Error {
  constructor(message = 'Resource has expired') {
    super(message)
    this.name = 'ResourceExpiredError'
  }
}
